let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cnxxZ")).then(() => parcelRequire('awnYY'));